









import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { fixedHtmlData, ContainerDimensions } from "@/services/posts/postTypes/fixedhtml";
import { BehaviorEnum } from "@/services/posts/types";
@Component
export default class VideoSubComponent extends Vue {
    @Prop() properties!: fixedHtmlData;
    @Prop() containerDimensions!: ContainerDimensions;

    // Watch
    @Watch("properties.behavior", { immediate: true }) behaviorChanged() {
        this.setDisplayVideoStyle();
    }

    // load cropper when media container dimensions changes
    @Watch("containerDimensions", { deep: true }) containerDimensionsChanged() {
        this.loadVideo();
    }

    // - Data Properties -
    staticVideo = {} as HTMLVideoElement;
    videoStyle = "";
    ratio = 1;

    // Video display properties
    video = {
        width: 0,
        height: 0
    }

    // Video dimensions
    videoSize = {
        width: 0,
        height: 0,
        origWidth: 0,
        origHeight: 0
    };

    // Container dimensions
    containerSize = {
        width: 300,
        height: 300,
        origWidth: 0,
        origHeight: 0
    };

    // Computed
    get src() {
        return this.properties.src;
    }

    get videoSrc(): string {
        const roundedHeight = Math.round(this.containerDimensions.height);
        const roundedWidth = Math.round(this.containerDimensions.width);
        return `${this.src}/${roundedHeight}/${roundedWidth}`;
    }

    // Lifecycle Hooks
    mounted() {
        this.staticVideo = this.$refs.video as HTMLVideoElement;
        this.staticVideo.autoplay = true;
        this.loadVideo();
    }

    // Methods
    loadVideo() {
        const self = this;
        var video = this.staticVideo;
        // On video load set video duration, calculate Aspect ratio, Calculate Video Style based on the behavior and pass Video size data to MediaComponentForm for saving.
        video.onloadeddata = () => {
            this.$emit("setDuration", this.staticVideo.duration);
            self.video.width = video.videoWidth;
            self.video.height = video.videoHeight;
            self.calcAspectRatio(self.containerDimensions.width, self.containerDimensions.height, 200, 200, video.videoWidth, video.videoHeight);
            self.setDisplayVideoStyle();
            this.$emit("videoLoaded", this.video);
        };
        this.staticVideo.src = this.videoSrc;
        this.staticVideo.muted = true;
        this.staticVideo.play();
    }

    calcAspectRatio(srcWidth: number, srcHeight: number, maxWidth: number, maxHeight: number, videoWidth: number, videoHeight: number) {
        let ratio = Math.min(maxWidth / srcWidth, maxHeight / srcHeight);
        if (ratio > 1) ratio = 1;

        const calc = { width: srcWidth * ratio, height: srcHeight * ratio, ratio };
        this.containerSize.width = calc.width;
        this.containerSize.height = calc.height;
        this.containerSize.origWidth = calc.width;
        this.containerSize.origHeight = calc.height;
        this.videoSize.width = videoWidth * calc.ratio;
        this.videoSize.height = videoHeight * calc.ratio;
        this.videoSize.origWidth = videoWidth * calc.ratio;
        this.videoSize.origHeight = videoHeight * calc.ratio;
    }

    setDisplayVideoStyle() {
        this.videoStyle = "";
        this.ratio = Math.max(this.containerDimensions.width / this.video.width, this.containerDimensions.height / this.video.height);
        if (this.properties.behavior === BehaviorEnum.crop) {
            if (this.ratio < 1) this.videoStyle = `transform: scale(${this.ratio}) translate(-50%, -50%)`;
        }

        if (this.properties.behavior === BehaviorEnum.letterBox) {
            if (this.video.width > this.containerDimensions.width || this.video.height > this.containerDimensions.height) {
                const ratio = Math.min(this.containerDimensions.width / this.video.width, this.containerDimensions.height / this.video.height);
                this.videoStyle = `
                    width: ${this.video.width * ratio}px;
                    height: ${this.video.height * ratio}px;
                `;
            }
        }
    }
}
